import Vue from 'vue';
import VueFlipCounter from 'vue-flip-counter';

Vue.use(VueFlipCounter);
